export default "__VITE_ASSET__nHlLCahn__"